<div class="h-14 bg-white flex flex-row items-center justify-between px-4">
  <!-- logo -->
  <img
    class="h-7 cursor-pointer"
    src="assets/layout/basic-layout/pacemaker_logo_blue_text_black.svg"
    alt="Pacemaker Logo"
    [routerLink]="['/']"
  />

  <!-- right section: notification bell + profile -->
  <div class="flex flex-row items-center gap-5">
    @if (chatEnabled()) {
      <pm-agent-chat-button />
    }

    <!-- notification bell -->
    @if (subscriptionService.isReplenishmentEnabled()) {
      <pm-button
        variant="subdued"
        size="normal"
        [icon]="bellIcon"
        [badgeCount]="notificationState.unreadCount()"
        [isActive]="isNotificationPanelOpen"
        #notificationTrigger="cdkMenuTriggerFor"
        [cdkMenuTriggerFor]="notificationDropdown"
        (cdkMenuOpened)="isNotificationPanelOpen = true"
        (cdkMenuClosed)="isNotificationPanelOpen = false"
        [cdkMenuPosition]="[
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          },
        ]"
      />
    }

    <!-- trigger dropdown section -->
    <div
      class="flex flex-row gap-0.5 items-center cursor-pointer"
      #profileTrigger="cdkMenuTriggerFor"
      [cdkMenuTriggerFor]="profileDropdownMenu"
      (click)="$event.stopPropagation()"
      (pointerdown)="toggleMenu($event)"
      (cdkMenuClosed)="this.isOpened = false"
      (cdkMenuOpened)="this.isOpened = true"
      [cdkMenuPosition]="[
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]"
    >
      <pm-monogram-circle
        [initials]="[userFirstName(), userLastName()] | monogram"
      />
      <div class="flex flex-row items-center gap-0.5">
        <span
          class="h-6 w-6 transition-all text-content-title"
          [inlineSVG]="'assets/layout/basic-layout/keyboard-arrow-down.svg'"
          alt="Dropdown"
          [ngClass]="{
            'transform rotate-180': !this.profileTrigger()?.isOpen(),
          }"
        ></span>
      </div>
    </div>
  </div>

  <!-- notification dropdown -->
  <ng-template #notificationDropdown>
    <div cdkMenu class="mt-2">
      <pm-notification-panel (closePanel)="closeNotificationPanel()" />
    </div>
  </ng-template>

  <!-- profile dropdown content -->
  <ng-template #profileDropdownMenu>
    <div
      cdkMenu
      [@menuTriggerAnimation]="true"
      class="w-full drop-shadow rounded-md bg-white min-w-80 flex flex-col mt-2"
    >
      <!-- user infos -->
      <div
        class="grid grid-cols-[32px_minmax(0,1fr)] grid-rows-2 gap-x-2 gap-y-0.5 p-4 pb-2"
      >
        <pm-monogram-circle
          class="col-span-1 self-center justify-self-center row-span-2"
          [initials]="[userFirstName(), userLastName()] | monogram"
        />
        <p class="col-span-1 text-sm text-content-title">{{ userName() }}</p>
        <p class="col-span-1 text-xs text-content-subdued">
          {{ userEmail() }}
        </p>
      </div>

      <!-- divider -->
      <div class="bg-border h-[1px] w-full"></div>

      <!-- menu items  -->
      <div class="flex flex-col p-2">
        @for (item of this.menuStructureService.headerMenu; track $index) {
          <pm-nav-item [navItem]="item" (clickNavItem)="closeMenu()" />
        }
      </div>
    </div>
  </ng-template>
</div>
